<template>
    <div style="width:100%; height:100%;">
        <div class="week-menu-item" v-for="(day, index) in days" @click="onDayClick(day,index)">
            <p class="big-text" :style="{'color': getBigTextColor(day.selected)}">{{day.dayOfMonth + " " + day.monthName}}</p>
            <p class="small-text" :style="{'color': getSmallTextColor(day.selected)}">{{day.day}}</p>
            <div class="selected-indicator" v-if="day.selected"></div>
        </div>
    </div>
</template>

<script>

    import moment from 'moment-timezone';

    export default {
        name: "week-menu",
        data() {
            return {
                days: [],
                viewBox: "0 0 0 0"
            }
        },
        methods: {
            createDays() {
                var days = [];
                for (let i = 0; i < 7; i++) {
                    let currentDate = moment();
                    let date = currentDate.subtract(i, 'day');
                    days.push({
                        date:  date.format("YYYY/MM/DD"),
                        dayOfMonth: date.format("DD"),
                        monthName: date.format("MMM").toUpperCase(),
                        day: date.format("ddd").toUpperCase(),
                        selected: false
                    });
                }
                days[0].selected = true;
                days = days.reverse();
                this.days = days;
            },
            getSvgX(index) {
                return (14.2857 * index) + "%";
            },
            setViewBox(containerWidth, containerHeight) {
                this.viewBox = "0 0 " + containerWidth + " " + containerHeight;
            },
            getBigTextColor(selected) {
                return selected ? 'rgb(116,32,245)' : 'white';
            },
            getSmallTextColor(selected) {
                return selected ? 'rgb(116,32,245)' : 'rgb(30,50,61)';
            },
            onDayClick(date, index) {
                let currentSelectedDate = this.getSelectedDate();
                if (date == currentSelectedDate) return;
                for(let i = 0; i < this.days.length; i++) {
                    this.days[i].selected = false;
                }
                this.days[index].selected = true;
                this.$emit('dateSelected', this.days[index]);
            },
            getSelectedDate() {
                for (let i = 0; i < this.days.length; i++) {
                    if(this.days[i].selected)
                        return this.days[i];
                }
            }
        },
        mounted() {
            this.createDays();
        }
    }
</script>

<style scoped>

    p {
        margin: 0;
        color: purple;
    }

    .week-menu-item {
        width: 14.2857%;
        height: 100%;
        display: inline-block;
        position: relative;
        cursor: pointer;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
    }

    .big-text {
        font-size: 14px;
        font-family: 'Digital-Serial-Bold';
        width: 100%;
        text-align: center;
    }

    .small-text {
        font-size: 12px;
        font-family: 'Digital-Serial-Bold';
        width: 100%;
        text-align: center;
    }

    .selected-indicator {
        width: 100%;
        height: 10%;
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: rgb(116,32,245);
    }

</style>



// WEBPACK FOOTER //
// src/components/week-menu/WeekMenu.vue